import { call, put, takeLatest, select } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import { GET } from "../../api";
import { FETCH_PRODUCT_MODAL_DATA_LIST, SET_PRODUCT_MODAL_DATA_LIST } from "../actions";
import {setLoading} from "./action"



const getSelectedProductId = (state) => state.selectProductId.selectProductId;




export function* FetchProductModalDataSaga() {

    const selectedId = yield select(getSelectedProductId);
   
    try {

        const response = yield call(GET, `${ApiRouts.API_PRODUCT_MODAL_DATA}/${selectedId}`, {});

        if (response) {

            yield put({
                type: SET_PRODUCT_MODAL_DATA_LIST,
                payload: response.data.data
            });

        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
       //  yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* productModalDataSaga() {
    yield takeLatest(FETCH_PRODUCT_MODAL_DATA_LIST, FetchProductModalDataSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default productModalDataSaga;
